import { useTranslation } from "react-i18next";
import type { LocalizedText } from "@/mocks/articles";

export type Language = "en" | "pl" | "es" | "fr";

const SUPPORTED: Language[] = ["en", "pl", "es", "fr"];

export function useCurrentLanguage(): Language {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] as Language;
  return SUPPORTED.includes(lang) ? lang : "en";
}

export function localize(text: LocalizedText, lang: Language): string {
  return text[lang] ?? text.en;
}